import { withTheme } from '@vebox/etui-system';
import { createElement } from 'react';
import { _ as _objectWithoutProperties, b as _extends } from '../_rollupPluginBabelHelpers-3b7bd988.js';
import { Div } from '@vebox/etui-system-elements';

const _excluded = ["size", "position", "isPointerEventsDisabled", "children", "theme", "styles"];
function InputAddon(_ref) {
  let {
      size = 'default',
      position,
      isPointerEventsDisabled,
      children,
      theme,
      styles = {}
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/createElement(Div, _extends({
    position: "absolute",
    top: `calc(((${size === 'default' ? theme.shape.inputHeight : theme.shape.inputHeightSmall}px / 2) / 2) - 1px)`,
    right: position === 'end' ? `${theme.spacing.xs}px` : 'auto',
    left: position === 'start' ? `${theme.spacing.xs}px` : 'auto',
    pointerEvents: isPointerEventsDisabled ? 'none' : 'auto',
    lineHeight: 0
  }, styles.root, props), children);
}
var InputAddon$1 = withTheme(InputAddon);

export default InputAddon$1;
